import * as CL from '@design-system/component-library';
import { useState } from 'react';
import { t } from '../../common/i18n';
import { getAddOnDescription } from './addOnDependencyUtils';

import './AddOnDescription.scss';

export const AddOnDescription = ({ addOnGuidCode }: { addOnGuidCode: string }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <span className="addon-description">
      <button onClick={() => setIsOpen(!isOpen)} type="button">
        <div className="addon-description__content">
          <div className="addon-description__button-text">
            {isOpen ? t.ZBEP('Read less') : t.GJJF('Read more')}
            <CL.Icon
              className="addon-description__arrow"
              color="blue-600"
              icon={isOpen ? 'arrow-up' : 'arrow-down'}
              size="s"
              type="filled"
            />
          </div>
          {isOpen && <div>{getAddOnDescription(addOnGuidCode)}</div>}
        </div>
      </button>
    </span>
  );
};
